module.exports = __webpack_public_path__ + "img/wohneinheit-aktiv.1dcaf6da.svg";